import actionTypes from 'SRC/modules/redux/actionTypes'

export const setDiscounts = (discounts) => ({
  type: actionTypes.SET_PACKAGES_DISCOUNTS,
  payload: discounts
})
